import appApi from '../../../../../api/app-api';
import { CheckType } from '../../../../../api/types/reports/accountant/check.type';
import { ChecksSideBarFilterType } from '../side-bar/checks-side-bar-filter.type';
import { displayErrorText } from '../../../../../api/errors/api-error-codes';
import { toast } from 'react-toastify';

export const getReportCheckOperation = async (
  filters: ChecksSideBarFilterType,
  setData: (data: CheckType[]) => any,
  setLoading: (loading: boolean) => any,
) => {
  try {
    setLoading(true);
    const res = await appApi.getChecksReport(filters);
    if (res.data.errCode) {
      toast.warn(displayErrorText(res.data.errCode));
      setLoading(false);
      return;
    }
    setData(res.data.body);
    setLoading(false);
  } catch (e) {
    toast.error('משהו קרה, יש לנסות שוב בעוד מספר רגעים');
    setLoading(false);
  }
};
